import { z } from 'zod';

export const masterClassInformationSchema = z.object({
  title: z.string().min(3),
  clientIDs: z.array(z.string()).min(1),
  selectedClientID: z.string().optional(),
  patientCaseIDs: z.array(z.string()).min(1),
  selectedPatientCaseID: z.string().optional(),
});

export const createMasterClassFormSchema = masterClassInformationSchema;
export type CreateMasterClassFormData = z.infer<typeof createMasterClassFormSchema>;
